export default __webpack_public_path__ + "static/media/snapchat.2d9a910b.jpeg";